import {
  PULSE_CLICK_ACTION,
  PULSE_CLICK_CATEGORY,
  trackPulseClick,
} from './pulseClickIds';
import { PULSE_VIEW_ID } from './pulseViewIds';

/** Thank-you / order tracking — Cancel Order CTA. */
export const trackCancelOrderClick = ({
  order_id,
  page_path,
}: {
  order_id: string | number;
  page_path?: string;
}): void => {
  trackPulseClick({
    category: PULSE_CLICK_CATEGORY.ORDER_MANAGEMENT,
    action: PULSE_CLICK_ACTION.TAP_CANCEL_ORDER,
    label: null,
    view_id: PULSE_VIEW_ID.THANK_YOU,
    page_id: PULSE_CLICK_CATEGORY.ORDER_MANAGEMENT,
    page_path,
    additional_params: { order_id },
  });
};
